import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { RetrabalhoPallet } from '../../types/qualidade';
import { retrabalhosService, inspecoesService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<RetrabalhoPallet>[] = [
  {
    name: 'inspecao',
    label: 'Inspeção',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      inspecoesService.list,
      (item: any) => item.lote_info ?? `Inspeção ${item.id}`,
    ),
    required: true,
  },
  { name: 'acao', label: 'Ação', type: 'textarea', required: true },
  { name: 'responsavel', label: 'Responsável' },
  { name: 'custo', label: 'Custo', type: 'number' },
  { name: 'observacoes', label: 'Observações', type: 'textarea' },
];

export const RetrabalhosFormPage: React.FC = () => (
  <ResourceFormPage
    title="Retrabalho"
    description="Registre ações corretivas após inspeção."
    fields={fields}
    service={retrabalhosService}
    redirectPath="/admin/qualidade/retrabalhos"
    cancelPath="/admin/qualidade/retrabalhos"
  />
);
